import React from 'react'
import intl from 'react-intl-universal'
import { AuthenticationInputPropTypes } from 'utils/prop_types/AuthenticationInput'
import { Input, InputGroupAddon, Checkbox } from 'components/qstrap'
import Icon from 'components/shared/input/Icon'
import ValidationIcon from 'components/shared/input/ValidationIcon'

export default class PasswordInput extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      inputType: 'password',
    }

    this.handleShowPassword = this.handleShowPassword.bind(this)
  }

  handleShowPassword() {
    const swap = { password: 'text', text: 'password' }

    this.setState({
      inputType: swap[this.state.inputType],
    })
  }

  render() {
    const {
      icon,
      name,
      value,
      className,
      handleChange,
      valid,
    } = this.props

    return (
      <div className="input-group">
        <div>
          <Icon name={icon} />
          <Input
            name={name}
            type={this.state.inputType}
            onChange={handleChange}
            defaultValue={value}
            className={className}
            onBlur={handleChange}
            autoComplete="false"
          />
        </div>
        <ValidationIcon valid={valid} enabled />
        <InputGroupAddon>
          <Checkbox onChange={this.handleShowPassword} >
            { intl.get('account.show_password') }
          </Checkbox>
        </InputGroupAddon>
      </div>
    )
  }
}

PasswordInput.propTypes = AuthenticationInputPropTypes
PasswordInput.defaultProps = {
  type: 'text',
  validations: [],
  selectOptions: [],
}
